import { DatabaseId } from "@syla/shared/types/helpers/Id";
import { parseDate, parseOptional } from "@syla/shared/types/helpers/parsing";
import { TransportType } from "@syla/shared/types/helpers/TransportType";

import { DataSourceData } from "@syla/shared/types/responses/TransactionEvent";

export function parseDataSource(
  dataSource: TransportType<DataSourceData & { _id: DatabaseId }>,
): DataSourceData & { _id: DatabaseId } {
  return {
    ...dataSource,
    createdAt: parseOptional(dataSource.createdAt, parseDate),
    updatedAt: parseOptional(dataSource.updatedAt, parseDate),
  };
}
